"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const hooks_1 = require("common/hooks");
const classnames_1 = __importDefault(require("classnames"));
const core_1 = require("react-hook-schema/core");
const fieldWrapper_1 = require("./common/fieldWrapper");
const components_1 = require("utils/components");
const displayWrapper_1 = require("./common/displayWrapper");
const DateSchemaComponent = (props) => {
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(components_1.DatePickerStyled, Object.assign({ className: (0, classnames_1.default)("form-control", {
                "has-error": fieldState.invalid,
            }), date: value ? new Date(value) : null }, registerProps))));
};
DateSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("DateDisplayComponent", (value) => {
    const { formatDate } = (0, hooks_1.useFormatter)();
    return value ? formatDate(value) + "" : "";
});
exports.default = DateSchemaComponent;
